import React, { memo, useEffect } from 'react';
import { useInputValuesState } from '../../store/atoms/inputValuesState';
import { UsequestionsState } from '../../store/atoms/questionsState';
import { Question } from '../head/question';
import { TopOption } from '../ui/option/topOption/index.jsx';
import styles from './home.module.scss';

export const Home = memo(() => {
   const { setInputValues, setCurrentNum } = useInputValuesState();
   const { list } = UsequestionsState();

    useEffect(() => {
      setCurrentNum(0);
      setInputValues(
      Array(list.length)
        .fill()
        .map((e, index) => ({ id: index, term_id: null, name: '', num: 0 }))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  return (
    <>
      <div className={styles.inner}>
        <h2 className={styles.title}>
          <span className={styles.title_sub}>
            現場の状況が把握しづらい、お金の流れが見えない…
          </span>
          <span className={styles.title_main}>
            非効率な業務を改善するために、DX診断にチャレンジ！
          </span>
        </h2>
        <p className={styles.text}>
          15問の設問に答えることで、現場の強みや課題が見えてきます。
          <br />
          診断にチャレンジして現場の改善点を把握しましょう。
        </p>
        <div className={styles.divider}></div>
        <Question
          title={'最初にお客様の業務をお選びください'}
          subTitle={'あなたの会社の強みと改善点が分かります'}
        />
        <TopOption />
      </div>
    </>
  );
});
